var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0269775,
    width: 22,
    height: 20.9924,
    fill: "url(#pattern0_450_1454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_450_1454",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_450_1454",
    transform: "matrix(0.01 0 0 0.0109704 0 -0.0485207)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_450_1454",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA5hJREFUeAHtnbuO1DAUhkODkIAGjTMCiUtFQYfEA0yxik9SbLe0UPEm8BL7EkhUdIjteQIuT8ATrNDCGWIyuxxvLmPnZOw/0siR53Ls7xvbsWeSFAU2EAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEACBJRFYNc3TkugNHh0DZqLmyBC9Loku8OgYMBMIWdCXAkIWJIN7CgiBkK6HxBjSjR1uHF1qCzk3RN9SfpRE507CbrpIIYboR9eO0tzjOu6KcPsQouQbQpTA+8JCiI+MUj6EKIH3hYUQHxmlfAhRAu8LCyE+Mkr5EKIE3hcWQnxklPKzEPJks7ll6vrtuqpux+Z8v2keG2tfTo2TvJBnJyc3TV1/2C5BWHu2Oj6+OxVW3/seHB094nW20tpff8C+6nu99HzSQi7JcMvpkaT8k9HFmSQlWSGijA5W0Jbyn4wuzmgpyQoxRKdupVRK11X1KcSYsh0ziL5LMdpukqU0Uvck5SUr5F5VPSyt/eoFxd/iPbsvb8twLaSNYTabOxJ8KS9ZIVzZmFJiyOAyJy0klpRYMrIQElpKTBnZCAklJbaMrITsK2UOGdkJmSplLhlZChkrZU4Z2QrhivdO6P7OJT6b6yZ9RBehJphcJt6SP+xt6ykmg+Ypu5O8q/vWno2Z9ImFuJKZtRBmMVlKBBlcnuyFTJISSQaEMIF2G9xSIsrgoqCFtEIGHU21i4Uxf+SCkKIoBstwg/qeq8SuVUpp9kJGy4gsJWshk2VElJKtEEwMpQ7Tk+c7pY2/PZ63jMoe1DLao6lBR18Bx5TsWsgYGc7ynFKyEjJFxtxSshGyj4w5pWQhJISMuaQkLySkjDmkJC0khozYUpIVElNGTCmpCrlRWvvlun8thvqlb8gEc030zknsS1MVUpi6fl4S/RSlBF5C75mnfOTzU/pEuOeTFcIVFKUEluFAeqSMkrEtc+qX1rgkJZIMj5TRMrIQwpVcNc2LFdH7EKcfOPi+tB1TTsd0U7uflXSXtVvRQ9mHkIWZghAI6ScQ+/eQ/hLovQItRI+9GBlCRCx6mRCix16MDCEiFr1MCNFjL0aGEBGLXuZBCeGLDKd8EeXthWsO6ULK4lK6+xdh4ukiL6QMIUpdqW+mDiEQspi7/KDLWtiYpCoENwXrbgbmboymelMwpZ4SYUEABEAABEAABEAABEAABEAABEAABEAABEAABEAABEBg4QR+A19EKtKe9mDBAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBoxIcon);
export default __webpack_public_path__ + "static/media/closeBoxIcon.c414b0894e488d111bd65f7a934b70ba.svg";
export { ForwardRef as ReactComponent };